/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_both_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Race finishing positions for both drivers per race - lower is better`)
};

const es_f1_profile_tooltip_both_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posiciones de llegada de ambos pilotos por carrera - menor es mejor`)
};

const de_f1_profile_tooltip_both_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renn-Zielpositionen beider Fahrer pro Rennen — niedriger ist besser`)
};

const nl_f1_profile_tooltip_both_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finishposities van beide coureurs per race — lager is beter`)
};

const fr_f1_profile_tooltip_both_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positions d’arrivée en course pour les deux pilotes par course — plus bas est mieux`)
};

const it_f1_profile_tooltip_both_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizioni di arrivo in gara per entrambi i piloti per gara — più basso è meglio`)
};

const pt_br2_f1_profile_tooltip_both_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posições de chegada de ambos os pilotos por corrida — menor é melhor`)
};

const pt_f1_profile_tooltip_both_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posições de chegada de ambos os pilotos por corrida — menor é melhor`)
};

const ja_f1_profile_tooltip_both_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レースごとの両ドライバーのフィニッシュポジション — 低い方が良い`)
};

const zh_f1_profile_tooltip_both_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两位车手每场的正赛完赛名次 — 越低越好`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_both_drivers = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_both_drivers(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_both_drivers", locale)
	if (locale === "en") return en_f1_profile_tooltip_both_drivers(inputs)
	if (locale === "es") return es_f1_profile_tooltip_both_drivers(inputs)
	if (locale === "de") return de_f1_profile_tooltip_both_drivers(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_both_drivers(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_both_drivers(inputs)
	if (locale === "it") return it_f1_profile_tooltip_both_drivers(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_both_drivers(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_both_drivers(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_both_drivers(inputs)
	return zh_f1_profile_tooltip_both_drivers(inputs)
};